import React from 'react'
import { IsViewable } from 'component-library/__helpers/is-viewable'
import { AdUnit } from './AdUnit'
import { shouldShowBackground } from './util'
import { IsHydrating } from 'common/context-providers/is-hydrating'
import { AdSlotProps } from './AdUnitWrapper'
import { VisiblityBreakpoint, StyledAdUnit } from './AdUnit.styled'
import { AdEvent } from 'common/events/viewability-event'
import { SlotRenderEndedEvent } from '../gpt/GptAdProvider/components/GptManager'

/**
 * Raises the viewable event and wraps the actual ad unit with it's styles
 */
export interface ViewabilityAdUnitProps extends AdSlotProps {
    removeAdContainerStyles: boolean
    breakoutMargins: {
        left: number
        right: number
    }
    recievedAdSlot: boolean | undefined
    onEvent: (event: AdEvent) => void
    onSlotRenderEnded: (event: SlotRenderEndedEvent) => void
    onSlotMutation: () => void
    breakoutContainerRef: React.MutableRefObject<HTMLDivElement | null>
    shouldHide: boolean
    visibilityBreakpoints: VisiblityBreakpoint[]
}

export const ViewabilityAdUnit: React.FC<ViewabilityAdUnitProps> = ({
    removeAdContainerStyles,
    unitId,
    adState,
    breakoutMargins,
    recievedAdSlot,
    onEvent,
    onSlotRenderEnded,
    onSlotMutation,
    breakoutContainerRef,
    shouldHide,
    visibilityBreakpoints,
}) => {
    const showBackground = shouldShowBackground()
    const isHydrating = React.useContext(IsHydrating)

    return (
        <IsViewable viewableThresholdPercent={50}>
            {(ref, isViewable, threshold) => (
                <StyledAdUnit
                    ref={ref}
                    className={`ad-${unitId}`}
                    breakoutMargins={breakoutMargins}
                    showBackground={showBackground}
                    removeAdContainerStyles={removeAdContainerStyles}
                    hidden={shouldHide}
                    visibilityBreakpoints={visibilityBreakpoints}
                >
                    {!isHydrating && (
                        <AdUnit
                            unitId={unitId}
                            adState={adState}
                            isLoaded={recievedAdSlot}
                            isViewable={isViewable}
                            threshold={threshold}
                            onEvent={onEvent}
                            onSlotRenderEnded={onSlotRenderEnded}
                            onSlotMutation={onSlotMutation}
                            breakoutContainerRef={breakoutContainerRef}
                        />
                    )}
                </StyledAdUnit>
            )}
        </IsViewable>
    )
}
